import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from 'vuex-persist'
const vuexPersist = new VuexPersist({
    key: 'asiaalt-persist',
    storage: sessionStorage
})
Vue.use(Vuex);
var data = {
    slideWrapper: 'visible',
    authState: 'signIn',
    startdate: null,
    appclass: '',
    gqlmap: null,
    currentTable: null,
    tcd: 0,
    subgql: null,
    fund: null,
    TrancheII: false,
    mma: false,
    fundid: null,
    primaryTabs: "",
    secondaryTabs: "",
    onLine: true,
    env: window.location.hostname.split('.')[0] === "staging" ? 'staging' : window.location.hostname === 'localhost' ? 'development' : 'production',
    theme: null,
    showGrid: 0,
    user: false,
    spinner: true,
}
data.init = JSON.stringify(data);
export const store = new Vuex.Store({
    state: data,
    mutations: {
        change(state, props) {
            var key = Object.keys(props)[0];
            var val = props[key];
            state[key] = val;
        }
    },
    getters: {
        get: (state) => (prop) => {
            return state[prop]
        }
    },
    plugins: [vuexPersist.plugin]
})
